import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  menuList: [],
  selectMenu: "",
};

const MenuReducer = createSlice({
  name: "MenuReducer",
  initialState: initialState,
  reducers: {
    setMenuList: (state, { payload }) => {
      return {
        ...state,
        menuList: payload,
      };
    },
    setMenu: (state, { payload }) => {
      return {
        ...state,
        selectMenu: payload,
      };
    },

    updateMenu: (state, { payload }) => {
      console.log("payload", payload);

      let newList = [...state.menuList];
      console.log("newList", newList);
      for (let index = 0; index < newList.length; index++) {
        if (newList[index].menu_id === payload.menu_id) {
          newList[index] = payload;
        }
      }
      return {
        ...state,
        menuList: newList,
      };
    },
    addList: (state, { payload }) => {
      console.log("payload", payload);
      let newList = [...state.menuList];
      newList.push(payload);
      return {
        ...state,
        menuList: newList,
      };
    },
  },
});
export default MenuReducer;
